module.exports = __webpack_public_path__ + "img/ic_kaipiaoxinxi.9ef5a974.svg";